import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../../common/button/button.module';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { InputModule } from './../../forms/input/input.module';
import { TimeZonePickerDropdownModule } from './../../forms/time-zone-picker/time-zone-picker-dropdown/time-zone-picker-dropdown.module';
import { TimeZonePickerComponent } from './time-zone-picker.component';

@NgModule({
  declarations: [TimeZonePickerComponent],
  exports: [TimeZonePickerComponent],
  imports: [
    RtUICoreOverlayModule,
    CommonModule,
    ButtonModule,
    InputModule,
    TimeZonePickerDropdownModule,
  ],
})
export class TimeZonePickerModule {}
export { TimeZonePickerComponent } from './time-zone-picker.component';
